<template>
  <div class="form_wrap">
    <el-form :model="ruleForm" class="product_form">
      <el-form-item class="all_line" label="产品来源：" prop="productSource2" label-width="150px" :rules="[{ required: true, message: '请选择产品信息', trigger: 'blur' }]">
        <!-- <el-checkbox-group
          v-model="ruleForm.checkProductSource"
          @change="handleChange2"
        >
          <el-checkbox label="厂家直销">厂家直销</el-checkbox>
          <el-checkbox label="代理">代理</el-checkbox>
        </el-checkbox-group>-->
        <el-checkbox-group v-model="ruleForm.ProductSource" @change="handleChange2" :disabled="!auditStatus">
          <el-checkbox v-for="item in ProductSourceList" :label="item.value" :key="item.value" :checked="item.selected">{{ item.text }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <div class="btn_wrap" v-show="showTabs">
      <img src="@/assets/img/btn_add.png" alt @click="add" />
      <img src="@/assets/img/btn_delete.png" alt @click="del" />
    </div>
    <el-tabs v-model="editableTabsValue" v-show="showTabs" class="tab_wrap5" ref="tabs">
      <el-tab-pane key="1" label="厂家直销" name="1">
        <table class="table_1">
          <tbody>
            <tr>
              <th width="80px">
                <el-checkbox v-model="allDirectCheck"></el-checkbox>
              </th>
              <th>品牌名称</th>
            </tr>
            <tr v-for="(item, index) in directDealList" :key="index">
              <td>
                <el-checkbox v-model="item.check"></el-checkbox>
              </td>
              <td>
                <el-input v-model="item.AgentBrandName" :disabled="!auditStatus"></el-input>
              </td>
            </tr>
          </tbody>
        </table>
      </el-tab-pane>
      <el-tab-pane key="2" label="供应商代理" name="2">
        <table class="table_1 table_1_custom">
          <tbody>
            <tr>
              <th width="80px">
                <el-checkbox v-model="allAgentCheck" :disabled="!auditStatus"></el-checkbox>
              </th>
              <th width="25%">品牌名称</th>
              <th width="25%">代理厂家名称</th>
              <th width="25%">有效期限</th>
              <th width="25%">附件</th>
              <!-- <th>有效结束日期</th> -->
            </tr>
            <tr v-for="(item, index) in agentList" :key="index">
              <td>
                <el-checkbox v-model="item.check" :disabled="!auditStatus"></el-checkbox>
              </td>
              <td>
                <el-input v-model="item.AgentBrandName" :disabled="!auditStatus"></el-input>
              </td>
              <td>
                <el-input v-model="item.AgentManufacturer" :disabled="!auditStatus"></el-input>
              </td>
              <td class="custom_date custom_daterange">
                <el-date-picker :disabled="!auditStatus" v-model="item.AgencyDate" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" unlink-panels></el-date-picker>
              </td>
              <td style="text-align: left">
                <el-upload
                  class="upload_style"
                  style="margin-left: 6px; padding-bottom: 6px"
                  action="/SupplierLogin/UploadProductFile"
                  :on-success="handleSuccess"
                  :before-remove="beforeRemove"
                  :on-remove="handleRemove"
                  :before-upload="handleBeforeUpload"
                  :on-preview="handleDownLoad"
                  :file-list="item.fileList"
                  :auto-upload="true"
                  :headers="headers"
                  :data="{ id: index }"
                  :disabled="!auditStatus"
                  multiple
                  accept="application/pdf"
                  :http-request="uploadSectionFile"
                >
                  <el-button size="mini" type="primary"> <i class="el-icon-plus"></i>添加上传 </el-button>
                </el-upload>
              </td>
            </tr>
          </tbody>
        </table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  props: {
    ProductSource: Array,
    ProductSourceList: Array,
    AgentBrandList: Array,
    auditStatus: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      list: [],
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      fileList: [],
      ruleForm: {
        ProductSource: []
      },
      directDealList: [
        {
          AgentBrandType: 1,
          check: false,
          AgentBrandName: '',
          AgentManufacturer: '',
          AgencyDate: ['', '']
        }
      ],
      agentList: [
        {
          AgentBrandType: 2,
          check: false,
          AgentBrandName: '',
          AgentManufacturer: '',
          AgencyDate: ['', ''],
          fileList: []
        }
      ],
      showTabs: false,
      editableTabsValue: '1',
      allDirectCheck: '',
      allAgentCheck: ''
    }
  },
  watch: {
    allDirectCheck(val) {
      this.directDealList.forEach((element) => {
        if (element.hasOwnProperty('check')) {
          element.check = val
        }
      })
    },
    allAgentCheck(val) {
      this.agentList.forEach((element) => {
        if (element.hasOwnProperty('check')) {
          element.check = val
        }
      })
    },
    ProductSourceList(val) {
      if (val) {
        var that = this
        let val = []
        this.ProductSourceList.forEach((item) => {
          if (item.selected) {
            val.push(item.value)
          }
        })
        if (val.length == 0) {
          that.showTabs = false
        } else if (val.length == 1) {
          that.showTabs = true
          this.editableTabsValue = val[0]
          if (val[0] == '1') {
            that.$refs.tabs.$children[0].$refs.tabs[1].style.display = 'none'
            that.$refs.tabs.$children[0].$refs.tabs[0].style.display = 'inline-block'
          } else {
            that.$refs.tabs.$children[0].$refs.tabs[0].style.display = 'none'
            that.$refs.tabs.$children[0].$refs.tabs[1].style.display = 'inline-block'
          }
        } else {
          that.showTabs = true
          that.$refs.tabs.$children[0].$refs.tabs[0].style.display = 'inline-block'
          that.$refs.tabs.$children[0].$refs.tabs[1].style.display = 'inline-block'
        }

        this.agentList = this.AgentBrandList.filter((item) => {
          if (item.AgentBrandType == 2) {
            return item
          }
        })
        if (this.agentList.length == 0) {
          this.agentList = [
            {
              AgentBrandType: 2,
              check: false,
              AgentBrandName: '',
              AgentManufacturer: '',
              AgencyDate: ['', ''],
              fileList: []
            }
          ]
        }

        this.directDealList = this.AgentBrandList.filter((item) => {
          if (item.AgentBrandType == 1) {
            return item
          }
        })
        if (this.directDealList.length == 0) {
          this.directDealList = [
            {
              AgentBrandType: 1,
              check: false,
              AgentBrandName: '',
              AgentManufacturer: '',
              AgencyDate: ['', '']
            }
          ]
        }
      }
    }
  },
  mounted() {},
  methods: {
    ruleList() {
      this.list = []
      this.iserror = true
      if (this.ruleForm.ProductSource.length == 0) {
        this.$message.error('请选择产品信息！')
        this.iserror = false
      }
      if (this.ruleForm.ProductSource.indexOf('2') >= 0) {
        if (this.agentList.length == 0) {
          this.$message.error('请填写代理品牌信息！')
          this.iserror = false
          return
        } else {
          this.agentList.forEach((item) => {
            console.log('sss', item.fileList.length)
            if ((item.AgentBrandName == '' || item.AgentManufacturer == '' || item.AgencyDate[1] == '') && this.iserror) {
              console.log(this.iserror)
              this.$message.error('请填写代理品牌信息！')
              this.iserror = false
              return
            } else if (item.fileList.length == 0) {
              this.$message.error('请上传代理品牌（' + item.AgentBrandName + '）的相关附件！')
              this.iserror = false
            }
          })
        }
      }
      if (this.ruleForm.ProductSource.indexOf('1') >= 0) {
        if (this.directDealList.length == 0) {
          this.$message.error('请填写直销品牌信息！')
          this.iserror = false
          return
        } else {
          this.directDealList.forEach((item) => {
            if (!item.AgentBrandName && this.iserror) {
              this.$message.error('请填写直销品牌信息！')
              this.iserror = false
              return
            }
          })
        }
      }
      if (this.ruleForm.ProductSource.indexOf('1') >= 0) {
        this.list.push(...this.directDealList)
      }
      if (this.ruleForm.ProductSource.indexOf('2') >= 0) {
        this.list.push(...this.agentList)
      }
    },
    ruleList1() {
      this.list = []
      if (this.ruleForm.ProductSource.indexOf('1') >= 0) {
        this.list.push(...this.directDealList)
      }
      if (this.ruleForm.ProductSource.indexOf('2') >= 0) {
        this.list.push(...this.agentList)
      }
    },
    add() {
      if (this.editableTabsValue == '1') {
        this.directDealList.push({
          AgentBrandType: 1,
          check: false,
          AgentBrandName: '',
          AgentManufacturer: '',
          AgencyDate: ['', '']
        })
      } else {
        this.agentList.push({
          AgentBrandType: 2,
          check: false,
          AgentBrandName: '',
          AgentManufacturer: '',
          AgencyDate: ['', ''],
          fileList: []
        })
        window.console.log(this.agentList)
      }
    },
    del() {
      if (this.editableTabsValue == '1') {
        this.directDealList = this.directDealList.filter((item) => {
          return !item.check
        })
      }
      if (this.editableTabsValue == '2') {
        this.agentList = this.agentList.filter((item) => {
          return !item.check
        })
      }
    },
    handleChange2(val) {
      console.log(val)
      var that = this
      if (val.length == 0) {
        that.showTabs = false
      } else if (val.length == 1) {
        that.showTabs = true
        this.editableTabsValue = val[0]
        if (val[0] == '1') {
          that.$refs.tabs.$children[0].$refs.tabs[1].style.display = 'none'
          that.$refs.tabs.$children[0].$refs.tabs[0].style.display = 'inline-block'
        } else {
          that.$refs.tabs.$children[0].$refs.tabs[0].style.display = 'none'
          that.$refs.tabs.$children[0].$refs.tabs[1].style.display = 'inline-block'
        }
      } else {
        that.showTabs = true
        that.$refs.tabs.$children[0].$refs.tabs[0].style.display = 'inline-block'
        that.$refs.tabs.$children[0].$refs.tabs[1].style.display = 'inline-block'
      }
    },
    handleDownLoad(file) {
      let token = window.localStorage.getItem('loginToken')
      token = token.replace(/\+/g, '%2B')
      this.downloadfile(this.baseURL + 'SupplierLogin/DownLoadFile?fileId=' + file.id + '&remark=' + file.remark + '&token=' + token + '&fileName=' + file.name)
    },
    handleSuccess(response, file, fileList) {
      window.console.log(response, file, fileList)
    },
    handleBeforeUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      if (testmsg !== 'pdf' && testmsg !== 'PDF') {
        this.$message.error('请上传pdf文件!')
        return false
      }
      if (file.size > 200 * 1024 * 1024) {
        this.$message.error('请上传小于200M的文件！')
        return false
      }
    },
    beforeRemove(file) {
      let isDelete = true
      if (file && file.status === 'success') {
        isDelete = this.$confirm(`确定删除 ${file.name}？`)
      }
      return isDelete
    },
    handleRemove(file, fileList) {
      var vm = this
      if (file && file.status === 'success') {
        if (file.id == 0) {
          vm.$message({ type: 'success', message: '删除成功!' })
          vm.agentList.forEach((item) => {
            item.fileList = item.fileList.filter(function (item1) {
              return item1.remark != file.remark
            })
          })
        } else {
          vm.postRequest('SupplierLogin/DeleteProductFile?fileId=' + file.id).then(function (res) {
            if (res.data.errcode === 0) {
              vm.$message({ type: 'success', message: '删除成功!' })
              vm.agentList.forEach((item) => {
                item.fileList = item.fileList.filter(function (item1) {
                  return item1.id != file.id
                })
              })
            } else vm.$message.error('删除失败')
          })
        }
      }
    },
    uploadSectionFile(params) {
      const file = params.file
      var data = new window.FormData()
      data.append('file', file)
      this.uploadFileRequest('SupplierLogin/UploadFile', data).then((res) => {
        if (res.data.errcode == 0) {
          var file = {
            id: res.data.fileid,
            name: res.data.filename,
            remark: ''
          }
          if (this.agentList[params.data.id].fileList.length == 0) {
            var fileList = [
              {
                id: res.data.fileid,
                name: res.data.filename,
                remark: ''
              }
            ]
            this.agentList[params.data.id].fileList = fileList
          } else {
            this.agentList[params.data.id].fileList.push(file)
          }

          params.onSuccess()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.product_form {
  .el-form-item {
    margin-bottom: 5px !important;
  }
}
.form_wrap .btn_wrap {
  position: absolute;
  right: 2px;
  top: 42px;
  z-index: 100;
}

// .custom_date ::v-deep.el-range-editor{width: 100%!important;}
.custom_daterange ::v-deep.el-range-input {
  height: 34px;
  line-height: 34px;
  font-size: inherit;
}
.custom_daterange ::v-deep.el-date-editor {
  height: auto;
}
.datepicker_wrap {
  border: 1px solid #ccc;
  background: #fff;
  border-radius: 3px;
}
.datepicker_wrap ::v-deep.el-input__inner {
  border: none !important;
  border-radius: 4px;
  background: #fff;
}
.table_1_custom {
  tr {
    border-bottom: 1px solid #dbdbdd;
    td {
      vertical-align: middle;
    }
    tr:nth-last-child(1) {
      border-bottom: none;
    }
  }
}
.upload_style ::v-deep .el-upload-list {
  li {
    text-align: left;
  }
}
</style>
